import ACTION_TYPES from "../actions/type.action";

const initialState = {
	assessmentresponse: {},
	assessmentresponses:[],
	questionresponse: {},
	submitstatus: null,
	assessmentResult: {},
	loadingQuestion:false
};

const reducer = (state = initialState, action) => {
	const {
		type,
		payload
	} = action;

	switch (type) {
		case ACTION_TYPES.GET_ASSESSMENTRESPONSE:
			return {
				...state,
				assessmentresponse: payload
			};
		case ACTION_TYPES.FETCH_ALLASSESSMENTRESPONSES:
			return {
				...state,
				assessmentresponses: payload
			};
		case ACTION_TYPES.GET_QUESTIONRESPONSE:
			return {
				...state,
				questionresponse: payload,
				loadingQuestion:false
			};
		case ACTION_TYPES.CLEAR_ASSESSMENTRESPONSE:
			return {
				assessmentresponse: {},
				questionresponse: {}
			};
		case ACTION_TYPES.ASSESSMENT_SUBMIT:
			return {
				...state,
				submitstatus: payload
			};
		case ACTION_TYPES.ASSESSMENT_RESULT:
			return {
				...state,
				assessmentResult: payload
			}
		case ACTION_TYPES.LOADING_QUESTIONRESPONSE:
			return {
				...state,
				loadingQuestion: payload
			}


		default:
			return state;
	}
};

export default reducer;